<tr>
    <td class="py-2">
            <p-skeleton  *ngFor="let col of displayColumns"
            height="2rem" [styleClass]="'my-2 '+ class " borderRadius="16px" />   
    </td>
</tr>